import styled from "styled-components";
import { primaryColor } from "../../../../config";

export const Wrapper = styled.div`
    /* In your global stylesheet or scoped CSS module */

    .custom-collapse .ant-collapse-header {
        padding: 6px 0px !important; /* Adjust as needed */
    }

    .custom-collapse .ant-collapse-borderless > .ant-collapse-item {
        border-bottom: 1px solid var(--app-border);
    }

    .ant-select-multiple.ant-select-lg .ant-select-selection-overflow .ant-select-selection-item-content {
        font-size: 11px;
    }

    .ant-select-selector, .ant-input-number-outlined {
        background: var(--app-surface) !important;
        color: var(--app-text-muted) !important;
        // border-color: #fff !important;    
        min-height: 42px;
    }

    .ant-input-number .ant-input-number-input {
        padding: 9px 11px;
    }

    .ant-select-selection-item {
        font-size: 13px !important;
        font-weight: 500;
    }

    .ant-select-item {
        font-size: .95rem !important;
        font-weight: 500;
    }

    .ant-select .ant-select-arrow {
        height: 22px;
    }

    .ant-select .ant-select-selection-placeholder {
        font-size: 13px !important;
        color: var(--app-text-muted) !important;
        font-weight: 500;
    }

    .ant-picker-input input {
        font-size: 13px
    }

    .ant-picker-range {
        border: 1px solid var(--app-border);
    }

    .ant-select-multiple .ant-select-selection-item-content {
        font-size: 12px;
    }

    .apexcharts-legend-group-vertical {
        flex-direction: row;
        display: flex;
    }

    /* ── Account Overview panel (chart tab right column) ───────────────── */
    .account-overview-card {
        --aov-primary: ${primaryColor};
        --aov-banner-bg: rgba(244, 91, 104, 0.08);
        --aov-banner-border: rgba(244, 91, 104, 0.35);
        --aov-banner-title: ${primaryColor};
        --aov-tab-active-bg: ${primaryColor};
        --aov-tab-active-border: ${primaryColor};
        --aov-tab-active-text: #ffffff;
        --aov-tab-hover-bg: rgba(244, 91, 104, 0.08);
        --aov-tab-hover-border: ${primaryColor};
        --aov-tab-hover-text: ${primaryColor};
        --aov-profit-bg: rgba(80, 205, 137, 0.1);
        --aov-profit-border: #50cd89;
        --aov-profit-text: #47be7d;
        --aov-collapse-bg: var(--app-surface-alt);
        --aov-collapse-border: var(--app-border);
        --aov-collapse-header-bg: transparent;
        --aov-collapse-header-text: var(--app-text);
        --aov-collapse-header-hover-bg: var(--app-surface);
        --aov-collapse-active-bg: rgba(244, 91, 104, 0.1);
        --aov-collapse-active-text: #f45b68;
        --aov-collapse-content-bg: var(--app-surface);
        --aov-collapse-icon: var(--app-text-muted);
        --aov-collapse-icon-active: #f45b68;
        --aov-info-hover: #f45b68;

        background: var(--app-surface);
        border-color: var(--app-border) !important;
    }

    [data-bs-theme="dark"] & .account-overview-card {
        --aov-banner-bg: #252536;
        --aov-banner-border: var(--app-border);
        --aov-banner-title: var(--app-text);
        --aov-tab-hover-bg: rgba(244, 91, 104, 0.12);
        --aov-tab-hover-border: #ff8a96;
        --aov-tab-hover-text: #ff8a96;
        --aov-profit-bg: rgba(80, 205, 137, 0.14);
        --aov-profit-border: #50cd89;
        --aov-profit-text: #6ee7a8;
        --aov-collapse-bg: #252536;
        --aov-collapse-header-hover-bg: #2b2b40;
        --aov-collapse-active-bg: rgba(244, 91, 104, 0.18);
        --aov-collapse-active-text: #ff8a96;
        --aov-collapse-icon-active: #ff8a96;
        --aov-info-hover: #ff8a96;

        box-shadow: 0 0.35rem 1.25rem rgba(0, 0, 0, 0.18);
    }

    .account-overview-card .card-header,
    .account-overview-card .card-footer {
        background: var(--app-surface);
        border-color: var(--app-border) !important;
    }

    /* Header banner */
    .account-overview-banner {
        border: 1px solid var(--aov-banner-border) !important;
        background: var(--aov-banner-bg) !important;
    }

    .account-overview__banner-title {
        color: var(--aov-banner-title) !important;
    }

    /* Net profit footer */
    .net-profit-banner {
        border: 1px dashed var(--aov-profit-border) !important;
        background: var(--aov-profit-bg) !important;
    }

    .account-overview__profit-title,
    .account-overview__profit-value {
        color: var(--aov-profit-text) !important;
    }

    /* Collapse row text */
    .account-overview__row-title,
    .account-overview__row-amount {
        color: var(--app-text) !important;
    }

    .account-overview__child-label {
        color: var(--app-text-muted) !important;
    }

    .account-overview__child-value {
        color: var(--app-text) !important;
    }

    .account-overview__info-icon {
        color: var(--app-text-muted) !important;
    }

    .account-overview__info-icon:hover {
        color: var(--aov-info-hover) !important;
    }

    .account-overview__separator {
        border-color: var(--app-border) !important;
    }

    /* Collapse panel */
    .account-overview-card .account-overview-collapse.ant-collapse {
        background-color: var(--aov-collapse-bg) !important;
        border-radius: 6px;
        border: 1px solid var(--aov-collapse-border) !important;
    }

    .account-overview-card .account-overview-collapse > .ant-collapse-item {
        border-bottom: 1px solid var(--aov-collapse-border) !important;
    }

    .account-overview-card .account-overview-collapse > .ant-collapse-item:last-child {
        border-bottom: none !important;
    }

    .account-overview-card .account-overview-collapse .ant-collapse-header {
        background: var(--aov-collapse-header-bg) !important;
        color: var(--aov-collapse-header-text) !important;
        transition: background 0.15s ease, color 0.15s ease;
    }

    .account-overview-card .account-overview-collapse .ant-collapse-header:hover {
        background: var(--aov-collapse-header-hover-bg) !important;
    }

    .account-overview-card .account-overview-collapse .ant-collapse-header-text,
    .account-overview-card .account-overview-collapse .ant-collapse-header-text .account-overview__row-title,
    .account-overview-card .account-overview-collapse .ant-collapse-header-text .account-overview__row-amount {
        color: inherit !important;
    }

    .account-overview-card .account-overview-collapse .ant-collapse-item-active > .ant-collapse-header {
        background: var(--aov-collapse-active-bg) !important;
        color: var(--aov-collapse-active-text) !important;
    }

    .account-overview-card .account-overview-collapse .ant-collapse-item-active > .ant-collapse-header .account-overview__row-title,
    .account-overview-card .account-overview-collapse .ant-collapse-item-active > .ant-collapse-header .account-overview__row-amount {
        color: var(--aov-collapse-active-text) !important;
    }

    .account-overview-card .account-overview-collapse .ant-collapse-content {
        background-color: var(--aov-collapse-content-bg) !important;
        border-top: 1px solid var(--aov-collapse-border) !important;
        color: var(--app-text);
    }

    .account-overview-card .account-overview-collapse .ant-collapse-content-box {
        color: var(--app-text);
    }

    .account-overview-card .account-overview-collapse .ant-collapse-expand-icon {
        color: var(--aov-collapse-icon) !important;
    }

    .account-overview-card .account-overview-collapse .ant-collapse-item-active .ant-collapse-expand-icon {
        color: var(--aov-collapse-icon-active) !important;
    }

    /* Disabled rows (no children) */
    .account-overview-card .account-overview-collapse .ant-collapse-item-disabled > .ant-collapse-header {
        color: var(--app-text-muted) !important;
        cursor: default;
    }

    .account-overview-card .account-overview-collapse .ant-collapse-item-disabled .account-overview__row-title,
    .account-overview-card .account-overview-collapse .ant-collapse-item-disabled .account-overview__row-amount {
        color: var(--app-text-muted) !important;
    }

    .account-overview-card .section-header {
        font-size: 16px;
        font-weight: 700;
        margin-bottom: 10px;
        padding-left: 4px;
        color: var(--app-text);
        border-bottom: 1px solid var(--app-border);
    }
    
    .metrics-carousel .slick-prev::after,
    .metrics-carousel .slick-next::after {
        content: "" !important;
        display: none !important;
    }

    .metrics-carousel {
        height: 350px;
        overflow: hidden;
        position: relative;
        background: var(--app-surface);
    }
    
    .carousel-content-scrollable {
        height: 350px;
        overflow-y: auto !important;
        padding-bottom: 10px;
        background: var(--app-surface);
    }
    
    .metrics-carousel .slick-list,
    .metrics-carousel .slick-track,
    .metrics-carousel .slick-slide > div {
        height: 100%;
    }

    .metrics-carousel .slick-slide > div {
        display: flex;
        flex-direction: column;
    }
    
    .responsive-select-container {
        width: 100%;
    }
    
    .custom-select-width {
        width: 100% !important;
        margin-bottom: 10px;
    }
    
    @media (min-width: 768px) {
        .responsive-select-container {
            flex-direction: row;
            width: auto;
        }

        .custom-select-width {
            width: 200px !important;
            margin-bottom: 0;
        }
    }

    /* ── Carousel Header Tabs (Account Overview) ─────────────────────── */
    .account-overview-card .carousel-tabs {
        display: flex;
        gap: 6px;
        width: 100%;
        padding-bottom: 2px;
    }

    .account-overview-card .carousel-tab-btn {
        flex: 1;
        padding: 7px 8px;
        border: 1.5px solid var(--app-border);
        border-radius: 8px;
        background: transparent;
        color: var(--app-text-muted);
        font-size: 12.5px;
        font-weight: 600;
        cursor: pointer;
        transition: background 0.2s ease, color 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease, transform 0.15s ease;
        outline: none;
        white-space: nowrap;
        text-align: center;
    }

    .account-overview-card .carousel-tab-btn:hover:not(.active) {
        background: var(--aov-tab-hover-bg);
        border-color: var(--aov-tab-hover-border);
        color: var(--aov-tab-hover-text);
        transform: translateY(-1px);
    }

    .account-overview-card .carousel-tab-btn.active {
        background: var(--aov-tab-active-bg) !important;
        border-color: var(--aov-tab-active-border) !important;
        color: var(--aov-tab-active-text) !important;
        box-shadow: 0 3px 10px rgba(244, 91, 104, 0.35);
    }

    [data-bs-theme="dark"] & .account-overview-card .carousel-tab-btn.active {
        box-shadow: 0 3px 10px rgba(244, 91, 104, 0.4);
    }

    .account-overview-card .carousel-tab-btn:focus-visible {
        outline: 3px solid ${primaryColor};
        outline-offset: 2px;
    }
    canvas {
        width: 100% !important;
    }

    .dashboard-chart-card {
        background: var(--app-surface);
        border-color: var(--app-border) !important;
    }

    .dashboard-chart-card .card-header {
        border-bottom-color: var(--app-border) !important;
    }

    .dashboard-chart-card .card-label,
    .dashboard-chart-card .card-title {
        color: var(--app-text) !important;
    }

    [data-bs-theme="dark"] & .dashboard-chart-card {
        box-shadow: 0 0.35rem 1.25rem rgba(0, 0, 0, 0.18);
    }
`